import { useMemo } from 'react';

import { useUserId } from '~hooks/useUserId';
import { useGetGeneratedMediaQueryState } from '~services/api/generation/endpoints';

export const useGetMediaGenerationIsProcessingState = (
	type: 'image' | 'video'
) => {
	const userId = useUserId();
	const { data } = useGetGeneratedMediaQueryState({
		userId,
		omit: 0,
		select: 0,
	});

	return useMemo(
		() =>
			data?.media.some(
				(item) =>
					item.type === type &&
					!item.waitingDeletion &&
					item.status === 'processing'
			),
		[data, type]
	);
};
